export const globalYesNoRadioOptions = [
    {
        label: "Yes",
        value: 1
    },
    {
        label: "No",
        value: 0
    }
]

export const detailedSearchOptions = [
    {
        label: 'First name',
        value: 'first_name=',
        apiProp: 'first_name'
    },
    {
        label: 'Last name',
        value: 'last_name=',
        apiProp: 'last_name'
    },
    {
        label: 'DOB',
        value: 'dob=',
        apiProp: 'dob'
    },
    {
        label: 'Incident Date',
        value: 'incident_date=',
        apiProp: 'incident_date'
    },
    {
        label: 'NG Number',
        value: 'ng_number=',
        apiProp: 'ng_number'
    },
    {
        label: 'Chart Number (practice)',
        value: 'chart_number=',
        apiProp: 'chart_number'
    },
    {
        label: 'Include Archived',
        value: 'include_archived=',
        apiProp: 'include_archived',
        separated: true
    }
]

export const mainTaksHeaderData = [
    {
        name: "Date added",
    },
    {
        name: "Added by",
    },
    {
        name: "Note type",
    },
    {
        name: "Notes",
    },
    // {
    //     name: "Note Type",
    // },
    {
        name: "Priority",
    },
    {
        name: "Assigned to",
    },
    {
        name: "Action required",
    },
    {
        name: 'Due date'
    },
    {
        name: 'Actions'
    }
];


export const PatientsHeaderDataGenericBlock = [
    {
        groupName: 'Activity',
        items: [
            {
                name: "Last F/U Date",
                type: "flexibleDate",
                group: "case",
                flexibleGroup: "practices",
                label: "last_f_u_date",
            },
            {
                name: "Next F/U Date",
                type: "flexibleDate",
                group: "case",
                flexibleGroup: "practices",
                label: "next_f_u_date",
            },
            {
                name: "Note",
                type: "note",
                group: "case",
                label: 'notes'
            },
            {
                name: "Last Activity",
                type: "date",
                group: "case",
                label: "last_activity",
            },
            {
                name: "Date of Incident",
                type: "date",
                group: "case",
                label: "incident_date",
            },
        ]
    },
    {
        groupName: 'Demographic',
        items: [
            {
                name: "NG#",
                type: "flexibleDate",
                group: "patient",
                label: "person_number",
                isSticky: true,
            },
            {
                name: "Patient Name",
                type: "name",
                group: "patient",
                label: "name",
                special: "dob",
                // style: "full",
                isSticky: true,
            },
        ]
    },
    {
        groupName: 'Case Data',
        position: 3,
        items: [
            {
                name: "Type",
                type: "case_type_id",
                group: "case",
                label: "case_type_id",
            },
            {
                name: "Status",
                type: "case_status_id",
                group: "case",
                label: "case_status_id",
            },
            {
                name: "Level",
                type: "box",
                group: "case",
                label: "case_level_id",
            },
            {
                name: "COM/DUI/H&R",
                type: "icons",
                group: "case",
                label: "TODO",
            },
            {
                name: "Gen. Treating Status",
                type: "case_status_id",
                group: "case",
                label: "TOD2",
            },
        ]
    },
    {
        groupName: 'Attorney',
        position: 4,
        items: [
            {
                name: "Firm",
                type: "text",
                group: "attorney",
                label: "name",
            },
            {
                name: "Status",
                type: "atty_status",
                group: "attorney",
                label: "status_id",
            }
        ]
    },
];


export const AllPatientsHeaderDataGenericBlock = [
    {
        groupName: 'Activity',
        position: 1,
        items: [
            {
                name: "Last F/U Date",
                type: "flexibleDate",
                group: "case",
                flexibleGroup: "practices",
                label: "last_f_u_date",
            },
            {
                name: "Next F/U Date",
                type: "flexibleDate",
                group: "case",
                flexibleGroup: "practices",
                label: "next_f_u_date",
            },
            {
                name: "Note",
                type: "note",
                group: "case",
                label: 'notes'
            },
            {
                name: "Last Activity",
                type: "date",
                group: "case",
                label: "last_activity",
            },
            {
                name: "Date of Incident",
                type: "date",
                group: "case",
                label: "incident_date",
            },
        ]
    },
    {
        groupName: 'Demographic',
        position: 2,
        items: [
            {
                name: "NG#",
                type: "flexibleDate",
                group: "patient",
                label: "person_number",
                isSticky: true,
            },
            {
                name: "Patient Name",
                type: "text_link",
                group: "patient",
                label: "name",
                special: "dob",
                // style: "full",
                isSticky: true,
            },
        ]
    },
    {
        groupName: 'Case Data',
        position: 3,
        items: [
            {
                name: "Type",
                type: "case_type_id",
                group: "case",
                label: "case_type_id",
            },
            {
                name: "Status",
                type: "case_status_id",
                group: "case",
                label: "case_status_id",
            },
            {
                name: "Level",
                type: "box",
                group: "case",
                label: "case_level_id",
            },
            {
                name: "COM/DUI/H&R",
                type: "icons",
                group: "case",
                label: "TODO",
            },
            {
                name: "Gen. Treating Status",
                type: "case_status_id",
                group: "case",
                label: "TOD2",
            },
        ]
    },
    {
        groupName: 'Attorney',
        position: 4,
        items: [
            {
                name: "Firm",
                type: "text",
                group: "attorney",
                label: "name",
            },
            {
                name: "Status",
                type: "atty_status",
                group: "attorney",
                label: "status_id",
            }
        ]
    },
    {
        groupName: 'Liability',
        position: 4,
        items: [
            {
                name: "Carrier Name",
                type: "text",
                group: "liability",
                label: "name",
            },
            {
                name: "Status",
                type: "liability_status",
                group: "liability",
                label: "status_id",
            },
            {
                name: "Liability Limit Patient",
                type: "liability_status",
                group: "liability",
                label: "policy_limit_patient",
            },
            
        ]
    },
    {
        groupName: 'MedPay',
        position: 4,
        items: [
            {
                name: "Carrier Name",
                type: "text",
                group: "liability",
                label: "name",
            },
            {
                name: "Status",
                type: "liability_status",
                group: "liability",
                label: "mp_status_id",
            },
            {
                name: "Policy Limit",
                type: "liability_status",
                group: "liability",
                label: "mp_limits",
            },
            
        ]
    },
    {
        groupName: 'Um',
        position: 4,
        items: [
            {
                name: "Carrier Name",
                type: "text",
                group: "liability",
                label: "name",
            },
            {
                name: "Status",
                type: "liability_status",
                group: "liability",
                label: "um_status_id",
            },
            {
                name: "Policy Limit",
                type: "liability_status",
                group: "liability",
                label: "um_policy",
            },
            
        ]
    },
];

export const TAB_IDS = {
    ATTY: 0,
    LIABILITY: 1,
    MEDPAY: 2,
    UM: 3,
    MAJORMED: 5,
    CRIMEVICTIM: 4,
    WC: 6,
    SERVICES: 9,
    ASC: 13,
    SUMMARY: 7,
    TRANSPORTATION: 8,
    LIEN: 14,
    DOCUMENTS: 11,
    NOTES: 12,
    NEGOTIATION: 16,
    SOS: 17,
    SELF_PAY: 18,
    PROCO_DOCS: 19,
    FLAGS: 26,
    ALERTS: 36,
    HISTORY: 27,
    APPOINTMENTS: 15,
};

export const HIDDEN_TAB_IDS = {
    FLAGS: 26,
    ALERTS: 36,
    HISTORY: 27,
    APPOINTMENTS: 15,
}

export const tabs_button = [
    {
        name: "Attorney",
        id: 0,
        type: 'atty',
        tab: 'attorney',
        workQGroupName: 'Attorney',
        folder: 'attorneys',
        order: 1,
        permissions: 'attorney_'
    },
    {
        name: "Liability",
        id: 1,
        type: 'liability',
        tab: 'liability',
        workQGroupName: 'Liability',
        folder: 'liabilities',
        order: 2,
        permissions: 'liability_'
    },
    {
        name: "MP/PIP",
        id: 2,
        type: 'medpay',
        tab: 'medpay_pip',
        workQGroupName: 'MedPay',
        folder: 'mp_pip_um',
        order: 3,
        permissions: 'medpay_pip_'
    },
    {
        name: "UM",
        id: 3,
        type: 'um',
        tab: 'um',
        workQGroupName: 'Um',
        folder: 'mp_pip_um',
        order: 4,
        permissions: 'um_'
    },
    {
        name: "MM",
        id: 5,
        type: 'majormed',
        tab: 'major_med',
        workQGroupName: 'Major Med',
        folder: 'major_meds',
        order: 5,
        permissions: 'major_med_'
    },
    {
        name: "Crime Victims",
        id: 4,
        tobehighlighted: true,
        type: 'crimevictim',
        tab: 'crime_victim',
        workQGroupName: 'Crime Victims',
        folder: 'crime_victim',
        order: 6,
        permissions: 'crime_victim_'
    },    
    {
        name: "WC",
        id: 6,
        type: 'workercomp',
        tab: 'workers_comp',
        workQGroupName: 'Work Comp',
        folder: 'worker_comp',
        order: 7,
        permissions: 'workers_comp_'
    },
    {
        name: "Services",
        id: 9,
        tab: 'services',
        folder: 'services',
        order: 8,
        permissions: 'services_'
    },
    {
        name: "ASC",
        id: 13,
        tab: 'asc',
        folder: 'surgeries',
        order: 9,
        permissions: 'asc_'
    },
    {
        name: "Summary",
        id: 7,
        tab: 'case_summary',
        folder: null,
        order: 10,
        permissions: 'skip'
    },
    {
        name: "Transportation",
        id: 8,
        type: 'transportation',
        tab: 'transportation',
        workQGroupName: 'Transportation',
        folder: 'case_transportation',
        order: 11,
        permissions: 'transportation_'
    },
    {
        name: "Lien",
        id: 14,
        type: 'lien',
        tab: 'lien',
        folder: 'lien',
        order: 12,
        permissions: 'lien_'
    },
    {
        name: "Documents",
        id: 11,
        tab: 'documents',
        folder: 'documents',
        order: 13,
        // permissions: 'documents_'
        permissions: 'skip'
    },
    {
        name: "Notes",
        id: 12,
        tab: 'notes',
        folder: 'notes',
        order: 14,
        // permissions: 'notes_'
        permissions: 'skip'
    },
    {
        name: "Negotiation",
        id: 16,
        tab: 'negotiation',
        folder: 'case_negotiation',
        order: 15,
        permissions: 'negotiation_'
    },
    {
        name: "SOS",
        id: 17,
        tab: 'sos',
        folder: 'case_sos',
        order: 16,
        permissions: 'sos_',
        type: 'case_sos',
    },
    {
        name: "Self Pay",
        id: 18,
        type: 'selfpay',
        tab: 'self_pay',
        workQGroupName: 'Self Pay',
        folder: 'selfpay',
        order: 17,
        permissions: 'self_pay_'
    },
    {
        name: "Proco Docs",
        id: 19,
        type: 'procodocs',
        tab: 'proco_docs',
        folder: 'procodocs_documents',
        order: 18,
        permissions: 'procodocs_documents_'
    },
    {
        name: "Flags",
        id: 26,
        tab: 'flags',
        folder: 'case_flag',
        order: 99,
        permissions: 'skip'
    },
    {
        name: "Alerts",
        id: 36,
        tab: 'alerts',
        folder: 'case_alerts',
        order: 999,
        permissions: 'skip'
    },
    {
        name: "History",
        id: 27,
        tab: 'history',
        folder: null,
        order: 9999,
        permissions: 'history_'
    },
    {
        name: "Appointments",
        id: 15,
        tab: 'appointments',
        folder: 'appointments',
        order: 99999,
        permissions: 'appointments_'
    },
];

// export const umHeaderRadioFields = [
//     {
//         label: "UM",
//         value: 1, //0
//     },
//     {
//         label: "No UM",
//         value: 0, //1
//     },
// ];

// export const umTypeRadioFields = [
//     {
//         label: "Addon",
//         value: 0,
//     },
//     {
//         label: "Reduced",
//         value: 1,
//     },
// ];

export const medpayRadioFields = [ // not needed, but it is called on a filed
    {
        label: "MP",
        value: 0,
    },
    {
        label: "PIP",
        value: 1,
    },
    {
        label: "No MP",
        value: 2,
    },
];

// export const medpayPIPStatus = [
//     {
//         label: "PIP",
//         value: 1,
//     },
//     {
//         label: "No PIP",
//         value: 0,
//     }
// ];
// export const medpayMPStatus = [
//     {
//         label: "MP",
//         value: 1,
//     },
//     {
//         label: "No MP",
//         value: 0,
//     }
// ];

// export const medpayins_owner = [
//     {
//         label: 'Driver',
//         value: 1
//     },
//     {
//         label: 'Passenger',
//         value: 2
//     }
// ]

// export const liabilityOwnerRadio = [    
//     {
//         label: "Driver",
//         value: 1,
//     },
//     {
//         label: "Passenger (Household member)",
//         value: 2,
//     },
//     {
//         label: "Passenger (Non-Household member)",
//         value: 3,
//     },
// ];


export const surgicalDrawerBUttons = [
    {
        label: 'Referral for Surgical Evaluation & Medical Review',
        id: 1
    },
    {
        label: 'Surgical Review Team & Evaluations',
        id: 2
    },
    {
        label: 'Preoperative Test & Surgery Appointments',
        id: 3
    }
]

// export const reasonForDefferal = [
//     {
//         label: 'Further Conservative Treatment needed',
//         value: 'Further Conservative Treatment needed'
//     },
//     {
//         label: 'Medical Clearance',
//         value: 'Medical Clearance'
//     },
//     {
//         label: 'Cardiac Clearance',
//         value: 'Cardiac Clearance'
//     },
//     {
//         label: 'Inpatient Only',
//         value: 'Inpatient Only'
//     },
//     {
//         label: 'Updated MRI',
//         value: 'Updated MRI'
//     },
//     {
//         label: 'Discogram',
//         value: 'Discogram'
//     },
//     {
//         label: 'EMG/NVC',
//         value: 'EMG/NVC'
//     }
// ]

// export const statusOptions = [
//     {
//         label: 'Approved',
//         value: 1,
//         color_code: '#b1fbbf',
//         text_color: 'Green'
//     },
//     {
//         label: 'Denied',
//         value: 0, // 2
//         color_code: '#fee7e8',
//         text_color: 'Red'
//     },
//     {
//         label: 'Review',
//         value: 2, //3
//         color_code: '#fff3c4',
//         text_color: 'Yellow'
//     }
// ]

// export const surgeryRecomandation = [
//     {
//         label: 'Surgery Recommended',
//         value: 1
//     },
//     {
//         label: 'Surgery Not Recommended',
//         value: 2
//     },
//     {
//         label: 'Surgery Deffered with Reason',
//         value: 3
//     },
//     {
//         label: 'Surgery Approved',
//         value: 4
//     }
// ]

// export const assumedOptions = [
//     {
//         label: 'Assumed',
//         value: 1,
//         color: "Green"
//     },
//     {
//         label: 'Denied',
//         value: 0, //2
//         color: "Red"
//     },
//     {
//         label: 'Investigation',
//         value: 2, //3
//         color: "Orange"
//     }
// ]


// export const aicaStatusOptions = [
//     {
//         label: 'Discharged',
//         value: 1,
//         color: 'Red'
//     },
//     {
//         label: 'Treating',
//         value: 2,
//         color: 'Green'
//     },
//     {
//         label: 'Hold',
//         value: 3,
//         color: 'Red'
//     },
//     {
//         label: 'N/A',
//         value: 4,
//         color: 'Grey'
//     }
// ]


// export const checkStatusOptions = [
//     {
//         label: 'Accepted',
//         value: 'Accepted'
//     },
//     {
//         label: 'Hold',
//         value: 'Hold'
//     },
//     {
//         label: 'Ignore',
//         value: 'Ignore'
//     }
// ]
// export const newPaymentSourceOptions = [
//     {
//         label: 'Attorney',
//         value: 'Attorney'
//     },
//     {
//         label: 'Liability',
//         value: 'Liability'
//     },
//     // {
//     //     label: 'UM',
//     //     value: 'UM'
//     // }
// ]


// export const negotiatorOptions = [
//     {
//         label: 'Negotiator',
//         value: 'Negotiator',
//         true_name: 'negotiators'
//     },
//     {
//         label: 'Case Manager',
//         value: 'Case Manager',
//         true_name: 'case_managers'
//     },
//     {
//         label: 'Attorney',
//         value: 'Attorney',
//         true_name: 'attorneys'
//     }
// ]


// export const negotiationsTypeOptions = [
//     {
//         label: 'Attorney',
//         value: 'Attorney'
//     },
//     {
//         label: '3rd Party',
//         value: '3rd Party'
//     },
//     {
//         label: 'Patient Negotiation',
//         value: 'Patient Negotiation'
//     },
//     {
//         label: 'Litigation',
//         value: 'Litigation'
//     },
//     {
//         label: 'Court',
//         value: 'Court'
//     }
// ]

// export const liabilityDeniedOptions = [
//     {
//         label: 'No Insurance on Vehicle',
//         value: 'No Insurance on Vehicle'
//     },
//     {
//         label: 'Contested',
//         value: 'Contested'
//     },
//     {
//         label: 'At Fault',
//         value: 'At Fault'
//     },
// ]

// export const AT_Fault_Radio = [
//     {
//         label: 'Other Vehicle',
//         value: 1
//     },
//     {
//         label: 'Patient at fault',
//         value: 2
//     }
// ]

// export const HIOF_Selected_Options = [
//     {
//         label: 'Opt-Out',
//         value: 0
//     },
//     {
//         label: 'Opt-In',
//         value: 1
//     }
// ]


// export const OutOfStateRadioOptions = [
//     {
//         label: "Yes",
//         value: 1,
//     },
//     {
//         label: "No",
//         value: 0,
//     },
//     {
//         label: "All",
//         value: 3,
//     },
// ];


// new

// export const workersCompStatus = [
//     {
//         label: 'Approved',
//         value: 1
//     },
//     {
//         label: 'Denied',
//         value: 0
//     },
//     {
//         label: 'Controverted',
//         value: 2
//     }
// ]

// export const majorMedOwnerRadion = [
//     {
//         label: 'Self',
//         value: 1
//     },
//     {
//         label: 'Spouse',
//         value: 2
//     },
//     {
//         label: 'Child',
//         value: 3
//     }
// ]

// export const aplicationApprovedDeniedFields = [
//     {
//         label: 'Application Approved',
//         value: 1
//     },
//     {
//         label: 'Application Denied',
//         value: 0
//     }
// ]

// export const MASTER_STATUS = [
//     {
//         label: 'Active',
//         value: 1,
//         color: 'Green'
//     },
//     {
//         label: 'Archived',
//         value: 0,
//         color: 'Red'
//     }
// ]

// export const PAYMENT_TYPES_OPTIONS = [
//     {
//         label: 'Credit Card',
//         value: 'Credit Card',
//     },
//     {
//         label: 'Cash',
//         value: 'Cash',
//     },
//     {
//         label: 'Check',
//         value: 'Check',
//     }
// ]

// ################### new ######################## 
export const preferedLanguagesOptions = [
    {
        value: 'en',
        label: 'English',
    },
    {
        value: 'es',
        label: 'Spanish',
    },
    {
        value: 'fr',
        label: 'French',
    },
    {
        value: 'por',
        label: 'Portuguese',
    }
]

export const filtersFromData = {
    lien_status: [
        {
            label: 'Notice Of Intent',
            value: 'Notice Of Intent'
        },
        {
            label: 'NOI Mailed',
            value: 'NOI Mailed'
        },
        {
            label: 'Lien',
            value: 'Lien'
        },
        {
            label: 'Amended Lien(s)',
            value: 'Amended Lien(s)'
        },
        {
            label: 'Recorded Lien(s)',
            value: 'Recorded Lien(s)'
        },
        {
            label: 'Satisfied Lien(s)',
            value: 'Satisfied Lien(s)'
        }
    ],
    lien_stage: [
        {
            label: 'Notice Sent',
            value: 'notice_sent'
        },
        {
            label: 'Notice Recorded',
            value: 'notice_recorded'
        },
        {
            label: 'Lien Sent',
            value: 'lien_sent'
        },
        {
            label: 'Lien Recorded',
            value: 'lien_recorded'
        },
        {
            label: 'Amend Sent',
            value: 'amend_sent'
        },
        {
            label: 'Amend Recorded',
            value: 'amend_recorded'
        },
        {
            label: 'Satisfy Sent',
            value: 'satisfy_sent'
        },
        {
            label: 'Satisfy Recorded',
            value: 'satisfy_recorded'
        }
    ],
    surgical_stage: [
        {
            label: 1,
            value: 1
        },
        {
            label: 2,
            value: 2
        },
        {
            label: 3,
            value: 3
        },
        {
            label: 4,
            value: 4
        },
        {
            label: 5,
            value: 5
        },
        {
            label: 6,
            value: 6
        },
        {
            label: 7,
            value: 7
        },
    ],
    worker_comp_type: [
        {
            label: 'Attorney',
            value: 'attorney'
        },
        {
            label: 'ATP',
            value: 'atp'
        }
    ],
    discharge_status: [
        {
            label: 'Treating',
            value: 'treating'
        },
        {
            label: 'Pending',
            value: 'pending'
        },
        {
            label: 'Discharged',
            value: 'discharged'
        }
    ]
}

export const ATTY_REPRESENT_RADIO = [
    {
        label: 'Yes',
        value: 1
    },
    {
        label: 'No',
        value: 0
    }
]

export const HIPPA_RADIO = [
    {
        label: 'Yes',
        value: 1
    },
    {
        label: 'No',
        value: 0
    },
    {
        label: 'All',
        value: 'all'
    }
]

export const MM_NO_LONGER_BILLING_RADIO = [
    {
        label: 'Yes',
        value: 1
    },
    {
        label: 'No',
        value: 0
    },
    {
        label: 'All',
        value: 'all'
    }
]

export const HIOF_OPTION_RADIO = [
    {
        label: 'Opt-In',
        value: 1
    },
    {
        label: 'Opt-Out',
        value: 0
    },
    {
        label: 'All',
        value: 'all'
    }
]

export const tasks_table_header_cells = [
    {
        id: 1111111,
        name:'',
        sortable: false,
        label: 'go_to_case'
    },
    {
        id: 2222222,
        name:'NG#',
        sortable: false,
        label: 'go_to_case'
    },
    {
        id: 333333333,
        name:'Patient Name',
        sortable: true,
        label: 'patient.name'
    },
    {
        id: 1,
        name:'Date added',
        sortable: false,
        label: 'date_added'
    },
    {
        id: 2,
        name:'Added by',
        sortable: true,
        label: 'user.name'
    },
    {
        id: 3,
        name:'Note type',
        sortable: true,
        label: 'note_type.name'
    },
    {
        id: 4,
        name:'Notes',
        sortable: false,
        label: 'note'
    },
    {
        id: 5,
        name:'Priority',
        sortable: false,
        label: 'priority'
    },
    {
        id: 6,
        name:'Assigned to',
        sortable: false,
        label: 'assigned_to'
    },
    {
        id: 7,
        name:'Action required',
        sortable: true,
        label: 'note_action.name'
    },
    {
        id: 8,
        name:'Due date',
        sortable: true,
        label: 'due_date'
    },
    {
        id: 9,
        name:'Actions',
        sortable: true,
        label: 'action_needed'
    },
]

export const transfers_table_header_cells = [
    {
        id: 1,
        name:'NG #',
        sortable: false,
        label: 'person_number'
    },
    {
        id: 2,
        name:'Patient Name',
        sortable: false,
        label: 'patient_name'
    },
    {
        id: 3,
        name:'From',
        sortable: false,
        label: 'from'
    },
    {
        id: 4,
        name:'To',
        sortable: false,
        label: 'to'
    },
    {
        id: 5,
        name:'Status',
        sortable: false,
        label: 'status'
    },
    {
        id: 6,
        name:'Reason',
        sortable: false,
        label: 'reason'
    },
    {
        id: 7,
        name:'Date Of First Appointment',
        sortable: true,
        label: 'first_appointment_date'
    },
    {
        id: 8,
        name:'Actions',
        sortable: false,
        label: 'actions'
    }
]

export const referrals_table_header_cells = [
    {
        id: 1,
        name:'Patient Name',
        sortable: true,
        label: 'patient_name'
    },
    {
        id: 2,
        name:'Phone',
        sortable: true,
        label: 'phone'
    },
    {
        id: 3,
        name:'Email',
        sortable: true,
        label: 'email'
    },
    {
        id: 4,
        name:'Zipcode',
        sortable: true,
        label: 'zip'
    },
    {
        id: 5,
        name:'Date of Accident',
        sortable: true,
        label: 'date_of_accident'
    },
    {
        id: 6,
        name:'Type of Accident',
        sortable: true,
        label: 'accident_type'
    },
    {
        id: 7,
        name:'Law Firm',
        sortable: true,
        label: 'law_firm'
    },
    {
        id: 8,
        name:'Law Firm signed the patient?',
        sortable: true,
        label: 'has_signed'
    },
    {
        id: 9,
        name:'Status',
        sortable: true,
        label: 'status'
    },
    {
        id: 10,
        name:'Created at',
        sortable: true,
        label: 'created_at'
    }
]

export const history_table_header_cells = [
    {
        id: 22,
        name:'NG#',
        sortable: false,
        label: 'go_to_case'
    },
    {
        id: 333,
        name:'Patient Name',
        sortable: true,
        label: 'patient.name'
    },
    {
        id: 2,
        name:'Created At',
        sortable: false,
        label: 'created_at'
    },
    {
        id: 222,
        name:'Source',
        sortable: false,
        label: 'source'
    },
    {
        id: 5,
        name:'User',
        sortable: false,
        label: 'user'
    },    
    {
        id: 44,
        name:'Area',
        sortable: false,
        label: 'area'
    },
    {
        id: 3,
        name:'Description',
        sortable: false,
        label: 'message'
    },
    // {
    //     id: 4,
    //     name:'Type',
    //     sortable: true,
    //     label: 'type'
    // },
    
]

export const appointments_table_header_cells = [
    {
        id: 1,
        name:'NG Appt. #',
        sortable: false,
        label: 'go_to_case'
    },
    {
        id: 2,
        name:'Date',
        sortable: true,
        label: 'date'
    },
    {
        id: 3,
        name:'Location',
        sortable: false,
        label: 'location'
    },
    {
        id: 4,
        name:'Begin Time',
        sortable: false,
        label: 'begin_time'
    },
    {
        id: 5,
        name:'End Time',
        sortable: false,
        label: 'end_time'
    },
    {
        id: 6,
        name:'Description',
        sortable: false,
        label: 'description'
    },
    {
        id: 7,
        name:'Event',
        sortable: false,
        label: 'event'
    },
    {
        id: 12,
        name:'Department',
        sortable: false,
        label: 'department'
    },
    // {
    //     id: 8,
    //     name:'Kept',
    //     sortable: false,
    //     label: 'kept'
    // },
    // {
    //     id: 9,
    //     name:'Missed',
    //     sortable: false,
    //     label: 'missed'
    // },
    // {
    //     id: 10,
    //     name:'Cancelled',
    //     sortable: false,
    //     label: 'cancelled'
    // },
    // {
    //     id: 11,
    //     name:'Rescheduled',
    //     sortable: false,
    //     label: 'rescheduled'
    // }
    {
        id: 13,
        name:'Appointment Status',
        sortable: false,
        label: 'appointment_type'
    }
]

export const exports_table_header_cells = [
    {
        id: 2,
        name:'Created At',
        sortable: false,
        label: 'created_at'
    },
    // {
    //     id: 5,
    //     name:'User',
    //     sortable: false,
    //     label: 'user'
    // },
    {
        id: 7,
        name:'Work Q',
        sortable: false,
        label: 'work_q'
    },
    {
        id: 10,
        name:'Download',
        sortable: false,
        label: 'download'
    },
    {
        id: 18,
        name:'Records Count',
        sortable: false,
        label: 'records'
    }
]

export const surgicalReviewOutcomesOptions = [
    {
        label: 'Approved ',
        value: 1
    },
    {
        label: 'No further action needed',
        value: 2
    }
]

export const aicaDataOptions = [
    {
        status_title: 'Chiro Status',
        prefix: 'chiro'
    },
    {
        status_title: 'Medical Status',
        prefix: 'medical'
    },
    {
        status_title: 'PT Status',
        prefix: 'pt'
    },
    
]

export const dummyWorkQ = {
    "id": 2020202,
    "name": "child Attorney Q",
    "parent_id": 4,
    "note_type_id": 1,
    "slug": "attorney-q",
    "complex_filtering": null,
    "grouped_fields": [
        {
            "groupName": "Activity",
            "items": [
                {
                    "name": "Last F/U",
                    "type": "date",
                    "group": "work_queue_table_field",
                    "label": "last_fu_date",
                    "key": "activity_last_fu_date",
                    "sortable": 1
                },
                {
                    "name": "Next F/U",
                    "type": "date",
                    "group": "work_queue_table_field",
                    "label": "next_fu_date",
                    "key": "activity_next_fu_date",
                    "sortable": 1
                },
                {
                    "name": "Notes",
                    "type": "add_notes",
                    "group": "notes",
                    "label": "notes",
                    "key": "activity_note",
                    "sortable": 0,
                    "exportable": 0
                },
                {
                    "name": "Tasks",
                    "type": "add_tasks",
                    "group": "task_notes",
                    "label": "task_notes",
                    "key": "activity_task_note",
                    "sortable": 0,
                    "exportable": 0
                },
                {
                    "name": "Alerts",
                    "type": "add_alerts",
                    "group": "case_alerts",
                    "label": "case_alerts",
                    "key": "activity_case_alerts",
                    "sortable": 0,
                    "exportable": 0
                },
                {
                    "name": "Last Activity",
                    "type": "object",
                    "group": "case",
                    "label": "last_activity",
                    "key": "activity_last_activity",
                    "sortable": 1
                }
            ]
        },
        {
            "groupName": "Demographic",
            "items": [
                {
                    "name": "NG#",
                    "type": "text_copy",
                    "group": "patient",
                    "label": "person_number",
                    "isSticky": true,
                    "key": "demographic_ng",
                    "sortable": 1
                },
                {
                    "name": "Patient Name",
                    "type": "name",
                    "group": "patient",
                    "label": "name",
                    "isSticky": true,
                    "key": "demographic_patient_name",
                    "sortable": 1
                },
                {
                    "name": "DOB",
                    "type": "hover",
                    "group": "patient",
                    "label": "dob",
                    "key": "demographic_dob"
                }
            ]
        },
        {
            "groupName": "Case Data",
            "items": [
                {
                    "name": "Date of Incident",
                    "type": "date",
                    "group": "case",
                    "label": "incident_date",
                    "key": "activity_date_of_incident",
                    "sortable": 1
                },
                {
                    "name": "Type",
                    "type": "status",
                    "group": "case",
                    "label": "case_type_id",
                    "key": "case_data_type",
                    "sortable": 1
                },
                {
                    "name": "Payer Type",
                    "type": "status",
                    "group": "case",
                    "label": "case_payer_type_id",
                    "key": "case_data_payer_type",
                    "sortable": 1
                },
                {
                    "name": "Payer Status",
                    "type": "status",
                    "group": "case",
                    "label": "case_payer_status_id",
                    "key": "case_data_payer_status",
                    "sortable": 1
                },
                {
                    "name": "Master Status",
                    "type": "status",
                    "group": "case",
                    "label": "master_status_id",
                    "key": "case_data_master_status",
                    "sortable": 1
                },
                {
                    "name": "COM/DUI/H&R",
                    "type": "icons",
                    "group": "liability",
                    "label": "com_dui_hr",
                    "key": "case_data_com_dui_hr",
                    "sortable": 0
                },
                {
                    "name": "Gen. Treating Status",
                    "type": "status",
                    "group": "case",
                    "label": "gen_treating_status",
                    "key": "case_data_gen_treating_status",
                    "sortable": 0
                }
            ]
        },
        {
            "groupName": "Practice Data",
            "items": [
                {
                    "name": "Total Charges",
                    "type": "currency",
                    "group": "case",
                    "label": "total_charges",
                    "key": "practice_data_total_charges",
                    "sortable": 1
                },
                {
                    "name": "Total Balances",
                    "type": "currency",
                    "group": "case",
                    "label": "total_balances",
                    "key": "practice_data_total_balances",
                    "sortable": 1
                }
            ]
        },
        {
            "groupName": "Attorney",
            "items": [
                {
                    "name": "Firm",
                    "type": "text",
                    "group": "attorney",
                    "label": "name",
                    "key": "attorney_firm",
                    "sortable": 1
                },
                {
                    "name": "Status",
                    "type": "status",
                    "group": "attorney",
                    "label": "status_id",
                    "key": "attorney_status",
                    "sortable": 1
                }
            ]
        },
        {
            "groupName": "Liability",
            "items": [
                {
                    "name": "Status",
                    "type": "status",
                    "group": "liability",
                    "label": "liability_status",
                    "key": "liability_status",
                    "sortable": 1
                }
            ]
        }
    ],
    "filter_groups": [
        {
            "group": "Case",
            "key": "master_status",
            "label": "Master Status"
        },
        {
            "group": "Case",
            "key": "case_type",
            "label": "Case Type"
        },
        {
            "group": "Case",
            "key": "discharged_status",
            "label": "Treating/Discharged"
        },
        {
            "group": "Case",
            "key": "pt_filter",
            "label": "Payer Type - Active"
        },
        {
            "group": "Case",
            "key": "ps_filter",
            "label": "Payer Status - Active"
        },
        {
            "group": "Case",
            "key": "ps_filter_global",
            "label": "Payer Status - Global Search"
        },
        {
            "group": "Case",
            "key": "payer_type_filters",
            "label": "Payer Type/Payer Status Filter"
        },
        {
            "group": "Case Practice",
            "key": "practice",
            "label": "Practice"
        },
        {
            "group": "Case Practice",
            "key": "location",
            "label": "Clinic"
        },
        {
            "group": "Case Practice",
            "key": "balances",
            "label": "Balances"
        },
        {
            "group": "Case Practice",
            "key": "total_charges",
            "label": "Total Charges"
        },
        {
            "group": "Attorney",
            "key": "law_firm",
            "label": "Law Firm"
        },
        {
            "group": "Attorney",
            "key": "attorney",
            "label": "Attorney"
        },
        {
            "group": "Attorney",
            "key": "case_manager",
            "label": "Case Manager"
        },
        {
            "group": "Attorney",
            "key": "attorney_collection_rep",
            "label": "Collection Rep"
        },
        {
            "group": "Attorney",
            "key": "ihc_review",
            "label": "IHC Review"
        },
        {
            "group": "Attorney",
            "key": "attorney_status",
            "label": "Attorney Status"
        },
        {
            "group": "Attorney",
            "key": "attorney_status_type",
            "label": "Attorney Status Type"
        },
        {
            "group": "Attorney",
            "key": "attorney_legal_status",
            "label": "Attorney Legal Status"
        },
        {
            "group": "Attorney",
            "key": "attorney_represent",
            "label": "Attorney Represent"
        },
        {
            "group": "Liability",
            "key": "liability_carrier",
            "label": "Carrier"
        },
        {
            "group": "Liability",
            "key": "liability_adjuster",
            "label": "Adjuster"
        },
        {
            "group": "Liability",
            "key": "liability_status",
            "label": "Status"
        },
        {
            "group": "Major Med",
            "key": "major_med_carrier",
            "label": "Carrier"
        },
        {
            "group": "Major Med",
            "key": "major_med_adjuster",
            "label": "Adjuster"
        },
        {
            "group": "MP/PIP/UM",
            "key": "mp_pip_um_carrier",
            "label": "Carrier"
        },
        {
            "group": "MP/PIP/UM",
            "key": "mp_pip_um_adjuster",
            "label": "Adjuster"
        },
        {
            "group": "MP/PIP/UM",
            "key": "um_status",
            "label": "UM Status"
        },
        {
            "group": "MP/PIP/UM",
            "key": "um_neg_split",
            "label": "UM Split"
        },
        {
            "group": "MP/PIP/UM",
            "key": "mp_status",
            "label": "MedPay Status"
        },
        {
            "group": "MP/PIP/UM",
            "key": "pip_status",
            "label": "PIP Status"
        }
    ],
    "quick_filters": [],
    "exceptions_filters": {
        "attorney_pi_missing_practice_hipaas": false,
        "liability_pi_no_present": false,
        "mp_um_pi_no_auto_ins": false
    },
    "filter_conditions": {
        "master_status_filter_type": 2,
        "master_status": 1,
        "discharged_status_filter_type": 1,
        "discharged_status": [
            "discharged"
        ],
        "case_type_category_filter_type": null,
        "case_type_category": null,
        "case_type_filter_type": 1,
        "case_type": [
            1,
            2,
            5,
            14,
            17
        ],
        "initial_treatment_date_filter_type": null,
        "initial_treatment_date": null,
        "days_payer_type_filters_filter_type": null,
        "days_payer_type": null,
        "days_payer_status_filter_type": null,
        "days_payer_status": null,
        "liability_status_filter_type": null,
        "liability_status": null,
        "um_status_filter_type": null,
        "um_status": [],
        "um_neg_split_filter_type": null,
        "um_neg_split": null,
        "mp_status_filter_type": null,
        "mp_status": null,
        "payer_type_filters_filter_type": null,
        "payer_type_filters": [],
        "pt_filter_filter_type": 1,
        "pt_filter": [
            5,
            3,
            4,
            12,
            7
        ],
        "ps_filter_filter_type": null,
        "ps_filter": [],
        "ps_filter_global_filter_type": null,
        "ps_filter_global": [],
        "attorney_status_type_filter_type": null,
        "attorney_status_type": null,
        "attorney_status_filter_type": null,
        "attorney_status": [],
        "attorney_legal_status_filter_type": null,
        "attorney_legal_status": [],
        "attorney_represent_filter_type": 1,
        "attorney_represent": 1,
        "out_of_state_filter_type": null,
        "out_of_state": null,
        "missed_appointment_date_filter_type": null,
        "missed_appointment_date": null,
        "surgical_stage_filter_type": null,
        "surgical_stage": null,
        "negotiation_type_filter_type": null,
        "negotiation_type": null,
        "lien_status_filter_type": null,
        "lien_status": null,
        "lien_stage_filter_type": null,
        "lien_stage": null,
        "worker_comp_type_filter_type": null,
        "worker_comp_type": null
    },
    "teams": [],
    "slug_url": "attorney-q"
}


export const verificationStatusOptions = [
    {
        label: 'In Progress',
        value: 'in_progress'
    },
    {
        label: 'Under Investigation',
        value: 'under_investigation'
    },
    {
        label: 'Verified',
        value: 'verified'
    }
]